<template>
  <div class="code-editor mt-12">
    <div class="sticky-header">
      <el-row justify="space-between">
        <el-col class="text-left" :span="2">
          {{ title }}
        </el-col>
        <el-col class="text-right" :span="7">
          <el-popover
            v-if="isResponse"
            ref="popover"
            placement="left"
            title=""
            :width="20"
            trigger="click"
            content="Copied"
          >
            <template #reference>
              <el-button
                type="primary"
                size="default"
                @click="copied"
              >
                Copy to clipboard
              </el-button>
            </template>
          </el-popover>
        </el-col>
      </el-row>
    </div>
    <el-scrollbar max-height="472px">
      <div v-if="isResponse">
        <pre>{{ data }}</pre>
      </div>
      <template v-else>
        <div class="pt-20 pl-12 color-gray">
          Please send request to see response ...
        </div>
      </template>
    </el-scrollbar>
  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue'

const props = defineProps({
  title: {
    required: false,
    type: String,
    default: ''
  },
  data: {
    required: false,
    type: [String, Object],
    default: ''
  }
})
const isResponse = computed(() => {
  if (props.data) {
    return true
  }
  return false
})
const emit = defineEmits(['copyToClipboard'])
const copied = () => {
  emit('copyToClipboard', props.data)
}
</script>

<style lang="scss" scoped>
.code-editor {
  height: 472px;
  overflow: hidden;
  & .el-scrollbar {
    overflow-x: hidden;
    background-color: #f7f6f6;
    border-radius: 2px;
  }
  & .el-scrollbar__view pre {
    padding: 20px;
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
  }
  & .sticky-header {
    top: 0px;
    padding: 4px 8px 4px 8px;
    position: sticky;
    background: #F2F2F2;
  }
}
</style>
